const TRACKING_ID_ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const getCheckDigit = (payload: string): number => {
    let sum = 0;

    for (let index = 0; index < payload.length; index++) {
        const digit = TRACKING_ID_ALPHABET.indexOf(payload.charAt(index));
        const positionFromRight = payload.length - index;
        sum += positionFromRight % 2 === 1 ? digit * 2 + 1 : digit;
    }

    return (10 - (sum % 10)) % 10;
};

/**
 * Checks an order tracking id against its trailing check digit.
 * @param trackingId - Tracking id from the order tracking url, e.g. WFDZY4KKV0PHAWONK3K3.
 * @returns True when the id only contains 0-9/A-Z and its last character matches the check digit of the rest.
 */
export const isValidOrderTrackingId = (trackingId: string): boolean => {
    if (!/^[0-9A-Z]{2,}$/.test(trackingId)) {
        return false;
    }

    const payload = trackingId.slice(0, -1);
    return String(getCheckDigit(payload)) === trackingId.slice(-1);
};
